import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="relative w-full h-48 md:h-52 overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3">
            <span className="px-2 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              {article.category}
            </span>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-base font-heading font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/70">
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-user-line mr-1" />
              {article.author}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-calendar-line mr-1" />
              {article.publishedAt}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-time-line mr-1" />
              {article.readTime}分钟阅读
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}